import { Components, Theme } from '@mui/material/styles';

export const cssBaseLineConfigs: Components<Theme>['MuiCssBaseline'] = {
  styleOverrides: theme => ({
    body: {
      backgroundColor: theme.palette.grey[100],
    },
  }),
};
